import { forwardRef } from "react";

import { cva } from "class-variance-authority";
import type { VariantProps } from "class-variance-authority";
import { twMerge } from "tailwind-merge";

const textArea = cva(
  "focus:ring-brand-400 block w-full rounded-md border-0 py-1.5 text-gray-900 ring-1 ring-inset ring-gray-300 placeholder:text-gray-400 focus:ring-2 focus:ring-inset sm:text-sm sm:leading-6",
);

type TextAreaVariantProps = VariantProps<typeof textArea>;

export interface Props extends TextAreaVariantProps {
  id?: string;
  rows?: number;
  defaultValue?: string;
  value?: string;
  placeholder?: string;
  onChange?: (event: React.ChangeEvent<HTMLTextAreaElement>) => void;
  onBlur?: (event: React.FocusEvent<HTMLTextAreaElement>) => void;
  className?: string;
  disabled?: boolean;
}

const TextArea = forwardRef<HTMLTextAreaElement, Props>(
  (
    {
      id,
      rows = 3,
      defaultValue,
      value,
      placeholder,
      onChange,
      onBlur,
      className,
      disabled,
      ...rest
    },
    ref,
  ) => {
    return (
      <textarea
        id={id}
        rows={rows}
        defaultValue={defaultValue}
        value={value}
        placeholder={placeholder}
        onChange={onChange}
        onBlur={onBlur}
        className={twMerge(textArea({ className }))}
        disabled={disabled}
        ref={ref}
        {...rest}
      />
    );
  },
);

TextArea.displayName = "TextArea";

export default TextArea;
